import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: '#e8eaf6',
    border: '1px solid #c5cae9',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  icon: {
    color: '#3f51b5',
    fontSize: 22,
    marginTop: 2,
    flexShrink: 0,
  },
  text: {
    fontSize: '13px',
    color: '#333',
    lineHeight: 1.6,
  },
}));

const InfoBanner = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.banner}>
      <InfoOutlinedIcon className={classes.icon} />
      <Typography className={classes.text}>{children}</Typography>
    </Box>
  );
};

export default InfoBanner;
